import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import { observer } from "mobx-react-lite";
import { Hooks, Request, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { Big } = Util;

import useIntervalAsync from "hooks/useIntervalAsync";
import usePriceCurrencyConvert from "hooks/usePriceCurrencyConvert";
import useFormatBigNumber from "hooks/useFormatBigNumber";
// import useUpDownClass from "hooks/useUpDownClass";
import { Context } from "@xt/xtbase";
import store from "store";
import { getOneByThreeStatus } from "utils/method";
import Socket from "utils/socket/public";
import { get_ticker24h } from "api/v4/market";

import useUpDownClassTicker from "hooks/useUpDownClassTicker";
import XtScrollArrow from "components/xt/scroll/arrow";
import useCoinMemo from "components/pages/trade/_hook/useCoinMemo";
import Star from "components/pages/trade/_cmpt/market/container/star";

import styles from "./index.module.scss";

import { ClsUpDownEnum } from "store/app";

export interface TickerProps {
  s: string; //市场名称, btc_usdt
  c: string; //当前价格, 100.000
  cr: string; //涨跌幅 0.0582 -> 5.8%
  cv: string; //价格变动值
  h: string; //24H最高价 25891.63
  l: string; //24H最低价 24188.76
  q: string; //24H成交数量 btc
  v: string; //24H成交金额 usdt
}

const Main: React.FC = () => {
  const t = useTranslation();
  const [appState] = useContext(Context.XtContext);
  const { name } = store.market;

  const { coinQuantityPrecisionMarket, coinPricePrecisionMarket } = useCoinMemo();

  const [initTitle, setInitTitle] = useState<string>();
  useEffect(() => {
    setInitTitle(document.title);
  }, []);

  const [ticker, setTicker] = useState<TickerProps>();
  const priceCls = useUpDownClassTicker(ticker);
  useEffect(() => {
    const ary = [store.market.formatName(name), initTitle];
    if (ticker) {
      ary.unshift(ticker.c || "0");
    }

    document.title = ary.join("-");
  }, [name, ticker]);

  const apiReq = useCallback(async () => {
    // console.log("Request.XtAxios.asyncAwait ----------> get_ticker24h");
    const { err, data } = await Request.XtAxios.asyncAwait(get_ticker24h, {
      params: { symbol: name },
    });
    if (!err && data && data.length) {
      setTicker(data[0]);
    }
  }, [name]);
  const { clear } = useIntervalAsync(apiReq, 5e3);

  const getMessage = (market = name) => {
    return {
      event: `ticker@${market}`,
    };
  };
  const wsCallback = (data) => {
    // console.log("ticker@ ws data", data);
    if (data.s !== store.market.name) {
      console.log("ticker@ name !== data.s", store.market.name, data.s);
      return;
    }
    clear();
    setTicker(data);
  };
  useEffect(() => {
    Socket.addChannel(getMessage(), wsCallback);

    return () => {
      setTicker(undefined);
      Socket.removeChannel(getMessage());
    };
  }, [name]);

  const currentPriceConvert = usePriceCurrencyConvert({ value: ticker ? ticker.c : 0 });
  const volume_btc = useFormatBigNumber(ticker ? ticker.q : 0, coinQuantityPrecisionMarket);
  const volume_usdt = useFormatBigNumber(ticker ? ticker.v : 0, coinPricePrecisionMarket);

  const objCurrPrice = useMemo(() => {
    if (!ticker) return { lab: "--", convert: "--" };

    // console.log("error----", ticker, coinPricePrecisionMarket);

    return {
      lab: Big(ticker.c || 0).toFixedCy(coinPricePrecisionMarket),
      convert: currentPriceConvert,
    };
  }, [ticker, coinPricePrecisionMarket, currentPriceConvert, appState.currency]);
  const obj24hChange = useMemo(() => {
    if (!ticker) return {};

    const cls = getOneByThreeStatus({ gt: ClsUpDownEnum.up, lt: ClsUpDownEnum.down }, ticker.cv);
    const sign = getOneByThreeStatus({ gt: "+", lt: "", eq: "" }, ticker.cv);
    const cv = Big(ticker.cv || 0).toFixedCy(coinPricePrecisionMarket);
    const rise = Big(ticker.cr || 0)
      .times(100)
      .toFixed(2);

    return {
      cls,
      lab: `${cv} ${sign}${rise}%`,
    };
  }, [ticker, coinPricePrecisionMarket]);
  const obj24hX = useMemo(() => {
    if (!ticker) return {};
    return {
      high: Big(ticker.h || 0).toFixedCy(coinPricePrecisionMarket),
      low: Big(ticker.l || 0).toFixedCy(coinPricePrecisionMarket),
    };
  }, [ticker, coinPricePrecisionMarket]);

  const elUl = (
    <div className={styles.contentUl}>
      <div>
        <p>{t("trade.24hChange")}</p>
        <div className={obj24hChange.cls}>{obj24hChange.lab}</div>
      </div>
      <div>
        <p>{t("trade.24HHigh")}</p>
        <div>{obj24hX.high}</div>
      </div>
      <div>
        <p>{t("trade.24HLow")}</p>
        <div>{obj24hX.low}</div>
      </div>
      <div>
        <p>{t("trade.homeMarketTradeUp") + `(${name.split("_")[0].toUpperCase()})`}</p>
        <div>{volume_btc}</div>
      </div>
      <div>
        <p>{t("trade.homeMarketTradeUp2") + `(${name.split("_")[1].toUpperCase()})`}</p>
        <div>{volume_usdt}</div>
      </div>
    </div>
  );

  return (
    <>
      {!store.app.isH5 && <Star symbol={name} className={styles.star} placement="bottomLeft" isStarEmpty={true} />}

      <div className={styles.price}>
        <p className={priceCls}>{objCurrPrice.lab}</p>
        <div>{objCurrPrice.convert}</div>
      </div>

      {store.app.isH5 ? (
        elUl
      ) : (
        <XtScrollArrow resetEffect={name} className={styles.content}>
          {elUl}
        </XtScrollArrow>
      )}
    </>
  );
};

export default observer(Main);
